import React, { useState } from 'react';
import { MarketDivider } from '@market/react';
import { useTranslation } from 'react-i18next';
import ProfileTab from 'components/profile/ProfileTab';
import ProfileTabList from 'components/profile/ProfileTabList';
import CardGroupAccordion from './CardGroupAccordion';
import { useRetrieveReceiptSettingsQuery } from 'store/query/api-extensions/receiptSettings';

const CardGroupsSection: React.FC = () => {
  const { t } = useTranslation();
  const { data: receiptSettings, isFetching } =
    useRetrieveReceiptSettingsQuery();

  const cardGroups = receiptSettings?.cardGroups ?? [];
  const preferences = receiptSettings?.preferences ?? [];
  const [selectedIndex, setSelectedIndex] = useState(0);

  if (cardGroups.length === 0) {
    return null;
  }

  const safeIndex = Math.min(selectedIndex, cardGroups.length - 1);
  const activeGroup = cardGroups[safeIndex];

  return (
    <>
      <MarketDivider className="my-8"></MarketDivider>
      <h2 className={'heading-20 mt-4 mb-2'}>
        {t('profile.receiptSettings.receiptPreferenceToggles.title')}
      </h2>
      <p className="mb-6 text-gray-500">
        {t('profile.receiptSettings.cardGroup.subtitle')}
      </p>
      <ProfileTabList>
        {cardGroups.map((group, index) => (
          <ProfileTab
            key={index}
            id={String(index)}
            tabId={`card-group-tab-${index}`}
            controls={`card-group-panel-${index}`}
            selected={safeIndex === index}
            onSelected={(id) => setSelectedIndex(Number(id))}
          >
            {group.displayName}
          </ProfileTab>
        ))}
      </ProfileTabList>
      {activeGroup && (
        <div
          role="tabpanel"
          id={`card-group-panel-${safeIndex}`}
          aria-labelledby={`card-group-tab-${safeIndex}`}
        >
          <CardGroupAccordion
            key={safeIndex}
            cardGroup={activeGroup}
            isToggleDisabled={isFetching}
            preferences={preferences}
          />
        </div>
      )}
    </>
  );
};

export default CardGroupsSection;
